import { BCMSValidate } from "@bcm-dev/bcms-vite";
import React, { useEffect, useState } from "react";
import { ImageAsset, SVGAsset } from "res";
import UITextInput from "../UITextInput";
import "./styles.css";

/**
 * @function UISearch 
 * @param {STRING} value - Allows to set the value of the text input. 
 * @param {STRING} placeholder - Allows to set the placeholder of the text input. 
 * @param {STRING} className - Allows to add a className to the text input.  
 * @param {STRING} onChange - Event handler that allows the input to change it’s value when someone is typing in it. 
 * @returns {React.Component}
 * @example
 * <UISearch value="0.00" placeholder="placeholder" className="has-left-icon" icon={true} onChange={e => {handleChange(e)}}/>
 */
 export default function UIAmountInput(props) {
  const point = props.dataPoint ?? "";
  const [ state, setState ] = useState({ "input" : props.value ?? "", "close" : false });
  
  const onChange = (value, evt) => {
  

      setState({ 
        "input" :value , 
        "close" : value.length > 0 
      });
      if(props.onChange instanceof Function) {
          props.onChange(value, evt);
      }
    
  };
  const reset = evt => {
    setState({ "input" : "", "close" : false });

    if(props.onChange instanceof Function) {
      props.onChange("");
    }
  };
  const search = (value, evt) => {
    if(props.search instanceof Function) {
      props.search(value, evt);
    }
  };

  // Added useEffect to reset state when the props.value is either undefined or is an empty string
  useEffect(() => {
    const defaultState = { "input" : "", "close" : false };
    if((props.value === undefined || props.value === "") && state !== defaultState) {
      setState(defaultState);
    }
    else {

      setState({ "input" : props.value, "close" : true });
    }
  }, [ props.value ]);

  const className = props.className ?? "";
  const placeholder = props.placeholder ?? "";

  return (
      <div className={className + " ui-search-input has-left-icon"}>
          <div className="ui-search-input-container">
            <UITextInput placeholderText={placeholder} value={ state.input } onChange={ onChange } dataPoint={ point } />
              <SVGAsset id="MagnifyingGlassIcon" className="left-icon" data-point={ `${ point }_Icon` } />
              { state.close && <SVGAsset id="XIcon" className="x-icon" onClick={ reset } /> }
              { state.close && <SVGAsset className="magnifying-glass icon" id="MagnifyingGlassIcon" onClick={ search } /> }
          </div>
      </div>
  );
}